
export class AnimationStep{  
    constructor(JSONString){
        let parsedJSON = JSON.parse(JSONString);
        this.step = parsedJSON.step;
        this.start = parsedJSON.start;
        this.end = parsedJSON.end;
        this.description = parsedJSON.description || "Description not found";
        this.method = parsedJSON.method || "null";
        this.direction = parsedJSON.direction || "null";
        this.button = parsedJSON.button || "null";
        this.image = parsedJSON.image || "null";

        if(this.description!="Description not found")
            this.description = this.step + ". "+this.description;
    }
}